module.exports = __webpack_public_path__ + "img/1.2d4eb120.webp";